import {
  Alert,
  Button,
  Card,
  CardContent,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useTheme
} from "@mui/material"
import FormControl from "@mui/material/FormControl"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "react-toastify"
import useGetUserProfile from "../../../../../hooks/useGetUserProfile"
import paymentServices from "../../../../../services/payment"
import requests from "../../../../../services/requests"
import CustomSkeleton from "../../../../common/CustomSkeleton"
import SliderComponent from "../../../../common/inputs/SliderComponent.jsx"
import ValidationHelperText from "../../../../common/validation-helper-text"
import LandingCard from "../LandingCard"
import FormDialog from "./formDialog"
import { useRouter } from "next/router"

const TransferForm = ({ isMobile }) => {
  const theme = useTheme()
  const router = useRouter()
  const [landings, setLandings] = useState([])
  const [detailsDialog, setDetailsDialog] = useState({})
  const minimumTransferAmount = 500000

  const {
    setValue,
    control,
    handleSubmit: handleFirstSubmit,
    register: firstRegister,
    watch: firstWatch,
    formState: { errors: firstErrors }
  } = useForm({
    defaultValues: {
      userCardId: "",
      company: 0,
      amount: 0
    }
  })

  const { data: creditLayersData } = useGetUserProfile()

  const credits = creditLayersData?.credits ?? [];

  const { checkCreditTransferAvalibility, getTransferCreditAmounts } = requests
  const [amountData, setAmountData] = useState({
    minimumAmount: 0,
    maximumAmount: 0,
    coefficient: 0
  })
  const [disableAction, setDisableAction] = useState(true)
  const [open, setOpen] = useState(false)
  const userCardId = firstWatch("userCardId")

  const getAmountsList = async () => {
    setDisableAction(true)
    const selectedCredit = creditLayersData?.credits.find(credit => +credit.userCardId === +userCardId)
    if (selectedCredit) {
      setDetailsDialog(selectedCredit)
      getTransferCreditAmounts({
        UserCardId: selectedCredit?.userCardId,
        CreditLayerId: selectedCredit.creditLayerId
      }).then(response => {
        if (response?.data?.succeed) {
          setAmountData(response?.data.value)
          if (response?.data.value?.minimumAmount > 0) {
            setDisableAction(false)
          }
        } else {
          toast.error(response?.data?.message)
        }
      })
    } else {
      toast.error("لایه اعتباری انتخاب شده معتبر نمی باشد.")
    }
  }

  useEffect(() => {
    if (userCardId) {
      getAmountsList()
    }
  }, [userCardId])

  useEffect(() => {
    const init = async () => {
      const { data } = await checkCreditTransferAvalibility()
      if (data.succeed) {
        setDisableAction(false)
      } else {
        toast.error(data?.message)
        setDisableAction(true)
      }
    }
    init()
  }, [])

  useEffect(() => {
    paymentServices.getTransferCreditLandings().then(response => {
      setLandings(response.data.value)
    })
  }, [])

  const handleOpenModal = () => {
    // if (firstWatch("company") === 2107) {
    //   toast.error("در حال حاضر امکان انتقال اعتبار به دیجیکالا وجود ندارد.")
    // } else {
    //   setOpen(true)
    // }
    setOpen(true)
  }

  const onSelectMerchant = selectedMerchant => {
    setValue("company", selectedMerchant, { shouldValidate: true, shouldDirty: true })
  }

  return (
    <>
      <Grid container justifyContent='center' gap={2}>
        <Grid item xs={12} md={5} display='flex' flexDirection='column' my={2} sx={{ order: isMobile ? "2" : "1" }}>
          <Typography variant='h5' fontWeight='bold' textAlign='center' p={1}>
            پذیرنده های جت وام
          </Typography>
          <Card variant='outlined'>
            <CardContent sx={{ p: "0 !important" }}>
              <Grid container>
                <CustomSkeleton isLoading={landings && !!!landings?.length}>
                  {landings?.map(item => (
                    <LandingCard
                      key={item.code}
                      id={item.id}
                      onSelectMerchant={onSelectMerchant}
                      title={item.name}
                      logo={item.code ? `/images/landings/${item.code}.png` : "/images/no-photo.svg"}
                    />
                  ))}
                </CustomSkeleton>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} display='flex' flexDirection='column' my={2} sx={{ order: 1 }}>
          <Card variant='outlined'>
            <CardContent>
              <Typography variant='h5' fontWeight='bold' textAlign='center' p={1}>
                لطفا مبلغ و مقصد انتقال را وارد نمایید.{" "}
              </Typography>
              <Grid mb={2} border={`2px dotted ${theme.palette.primary.main}`} borderRadius={"15px"} p={1}>
                <Typography variant={"caption"}>
                  مبلغ وارد شده باید مضربی از {minimumTransferAmount.toLocaleString()} ریال باشد:
                </Typography>
              </Grid>
              <form onSubmit={handleFirstSubmit(handleOpenModal)}>
                <Grid display={"flex"} flexDirection='column' gap={2}>
                  <Grid>
                    <FormControl fullWidth>
                      <InputLabel>انتقال به</InputLabel>
                      <Select
                        fullWidth
                        label=' به انتقال'
                        {...firstRegister("company", {
                          required: { value: true, message: "انتخاب پذیرنده اعتبار الزامی است" }
                        })}
                        value={+firstWatch("company") > 0 ? +firstWatch("company") : ""}
                      >
                        {landings?.map(item => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          )
                        })}
                      </Select>
                      <ValidationHelperText
                        error={!!firstErrors?.company}
                        helperText={firstErrors?.company?.message as string}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel>انتخاب لایه اعتباری</InputLabel>
                      <Select
                        fullWidth
                        label='انتخاب لایه اعتباری'
                        {...firstRegister("userCardId", {
                          required: { value: true, message: "انتخاب لایه اعتباری الزامی است" }
                        })}
                      >
                        {credits?.map(item => (
                          <MenuItem key={item.userCardId} value={item.userCardId}>
                            {item.title}
                          </MenuItem>
                        ))}
                      </Select>

                      <ValidationHelperText
                        error={!!firstErrors?.userCardId}
                        helperText={firstErrors?.userCardId?.message as string}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    {amountData && amountData?.minimumAmount > 0 && (
                      <FormControl fullWidth>
                        <SliderComponent
                          min={amountData?.minimumAmount}
                          max={amountData?.maximumAmount}
                          step={amountData?.coefficient}
                          name='amount'
                          control={control}
                          props={{
                            ...firstRegister("amount", {
                              required: { value: true, message: "انتخاب مبلغ الزامی است" }
                            })
                          }}
                        />
                        <ValidationHelperText
                          error={!!firstErrors?.amount}
                          helperText={firstErrors?.amount?.message as string}
                        />
                      </FormControl>
                    )}
                    {amountData && amountData?.minimumAmount === 0 && userCardId && (
                      <Alert severity='error'>
                        <Typography> اعتبار شما کافی نمی باشد!</Typography>
                      </Alert>
                    )}
                  </Grid>

                  <Button disabled={disableAction} type='submit' size='medium' variant='contained' sx={{ my: 3 }}>
                    انتقال اعتبار
                  </Button>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>

        {open && landings && (
          <FormDialog
            open={open}
            setOpen={setOpen}
            detailsDialog={detailsDialog}
            setDisableAction={setDisableAction}
            firstWatch={firstWatch}
            companyList={landings}
          />
        )}
      </Grid>
    </>
  )
}

export default TransferForm
